import axios from "axios";
import { API_DOMAIN } from "../utils/constants";

export const saveBookedDemo = async (jsonData) => {
  return await axios.post(`${API_DOMAIN}/demo/add`, jsonData);
};
